import { NO_GROWTH_BOOK_TEST } from 'root-constants'

export const getCurrentOnboardingVariant = (
  growthBookVariantId: string,
): string => `ab_variant_${growthBookVariantId || NO_GROWTH_BOOK_TEST}`
